import Mark from './Mark';
import { IconInstagram, IconYouTube } from './Icons';

export default function Footer({ site }) {
  return (
    <footer className="footer">
      <div className="wrap footer-row">
        <div className="footer-id">
          <a className="footer-brand" href="#top" aria-label={`${site.name}, back to top`}><Mark /></a>
          <p className="footer-copy">© {new Date().getFullYear()} {site.copyright}</p>
        </div>
        <nav className="footer-links" aria-label="More">
          {site.showPress && <a href={site.pressLink}>{site.pressLabel}</a>}
          <a href={site.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram"><IconInstagram /></a>
          <a href={site.youtube} target="_blank" rel="noopener noreferrer" aria-label="YouTube"><IconYouTube /></a>
        </nav>
      </div>
    </footer>
  );
}
